import React, { Suspense } from 'react';
import { PlanningDetailContainer, PlanningTabStyled, TabListStyled, TabButtonStyled } from './styled';
import { PlanningViewDetailProps } from './types';
import { PlanningTab } from '../types';
import { SuspenseLoader, ErrorBoundary, usePlanning, PlanningActionType } from '@bechtel/client-common';
import { Progress } from './progress';
import { Plan } from './plan';
import { Timeline } from './timeline';
import { Trans } from '@lingui/macro';

export const PlanningViewDetail: React.FC<PlanningViewDetailProps> = ({
  expiredMilestoneStats,
  isListCollapsed,
  onTabChange,
  selectedProjectWeek,
  selectedTab,
}) => {
  const { planningDispatch, isReplan } = usePlanning();
  const resetReplan = () => {
    if (isReplan) {
      //Drawer values changed after replan. hance reset replan filter
      planningDispatch({
        type: PlanningActionType.ReplanMilestone,
        payload: {
          isReplan: false,
        },
      });
    }
  };
  return (
    <PlanningDetailContainer isListCollapsed={isListCollapsed}>
      <TabListStyled>
        <PlanningTabStyled>
          <TabButtonStyled
            selected={selectedTab === PlanningTab.PROGRESS}
            onClick={() => {
              onTabChange(PlanningTab.PROGRESS);
              resetReplan();
            }}
            data-testid="progress-tab"
          >
            <Trans>Progress</Trans>
          </TabButtonStyled>
        </PlanningTabStyled>
        <PlanningTabStyled>
          <TabButtonStyled
            selected={selectedTab === PlanningTab.PLAN}
            onClick={() => onTabChange(PlanningTab.PLAN)}
            data-testid="plan-tab"
          >
            <Trans>Plan</Trans>
          </TabButtonStyled>
        </PlanningTabStyled>
        <PlanningTabStyled>
          <TabButtonStyled
            selected={selectedTab === PlanningTab.TIMELINE}
            onClick={() => {
              onTabChange(PlanningTab.TIMELINE);
              resetReplan();
            }}
            data-testid="timeline-tab"
          >
            <Trans>Timeline</Trans>
          </TabButtonStyled>
        </PlanningTabStyled>
      </TabListStyled>
      {selectedTab === PlanningTab.PROGRESS && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <Progress selectedProjectWeek={selectedProjectWeek} />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab === PlanningTab.PLAN && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <Plan expiredMilestoneStats={expiredMilestoneStats}></Plan>
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab === PlanningTab.TIMELINE && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <Timeline />
          </Suspense>
        </ErrorBoundary>
      )}
    </PlanningDetailContainer>
  );
};
